var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-button',{attrs:{"variant":"warning"},on:{"click":_vm.update}},[_vm._v(" 更新 ")])}
var staticRenderFns = []

export { render, staticRenderFns }